import React from "react";
import VotingCard from "../../components/Voting/VotingCard/VotingCard";

import "./Vote.css";

const Vote = ({ballot}) => {
  return (
    <div className="votingContainer">
      {ballot && <VotingCard ballot={ballot} />}
    </div>
  );
};

export default Vote;
